import React, { Component } from 'react';

import WhiteBox from '../../components/WhiteBox';
import DatePicker from 'react-datepicker';
import { InputGroup } from 'reactstrap';

import CurrencySelector from './currency-selector';
import BorderButton from '../../components/BorderButton';

import moment from 'moment';
import DMPFilter from '../../components/DMPFilter';
import AdformRights from '../../components/AdformRights';
import axios from 'axios';

import 'date-fns';

const CPM_COST_MULTIPLIER = 1000000;

export default class NewLicenseConfigHeader extends Component {
  state = {
    dmp: '',
    dmpProductId: '',
    dmpProductDescription: '',
    withPartnerId: true,
    partnerId: '',
    licenseName: '',
    /*validUntil: moment()
            .add(1, 'years')
            .format('DD.MM.YYYY'),*/
    validUntil: moment().add(10, 'years'),

    validUntilValue: moment().add(1, 'years'),
    currency: 'USD',
    cpm: '1.00',
    cookieDuration: 30,
    disabled: true,
    currencies: [],
    countryId: null,
  };

  componentDidMount() {
    const l = this.props.license;
    if (l) {
      console.log('edit license ', l);
      const isDDPMarketplace =
        l.dmpProductId === 'AR_MARKETPLACE' && l.dmp === 'ddp';

      this.setState(
        {
          dmp: l.dmp || 'ddp',
          dmpProductId: l.dmpProductId,
          withPartnerId: l.dmpClientId ? true : false,
          partnerId: l.dmpClientId || '',
          licenseId: l.licenseId || '',
          licenseName: l.licenseName || '',
          validUntil: l.validUntil
            ? moment.unix(l.validUntil / 1000)
            : moment().add(10, 'years'),
          //l.validUntil ? moment.unix(l.validUntil / 1000).format('DD.MM.YYYY') : '',
          validUntilValue: l.validUntil
            ? l.validUntil
            : moment.unix(moment().add(10, 'years')),
          currency: l.currency || '',
          status: l.status || 'inactive',
          cpm: parseFloat(parseInt(l.cpmCost) / 1000000).toFixed(2) || '',
          editMode: this.props.editMode || false,
          disabled: false,
          disableCPM: isDDPMarketplace,
          cookieDuration: l.cookieDuration || 30,
          showMarketplaceMessage: isDDPMarketplace,
        },
        () => {
          if (this.state.partnerId != '' && this.state.licenseName != '') {
            this.setState({
              disabled: false,
            });
          }

          axios
            .get(
              '/currencies?dmp=' +
                this.state.dmp +
                '&product=' +
                this.state.dmpProductId
            )
            .then((response) => {
              console.log('currencies list', response, response.data.body);
              this.setState({
                currencies: response.data.body.map((c) => c.currency),
              });
            });
        }
      );
    } else {
      this.setState({
        licenseName:
          (this.props.audience && this.props.audience.audienceName) || '',
      });
    }
  }

  handleCMPChange = ({ target }) => {
    //console.log("cpm change", target)
    const cpm = target.value;
    if (cpm.match(/^[0-9.]*$/)) this.setState({ cpm });
  };

  handleSubmit = () => {
    let dataToUpdate = null;

    if (window.location.pathname === '/licenses/new') {
      dataToUpdate = { ...this.state };
      if (dataToUpdate.withPartnerId === false) delete dataToUpdate.partnerId;
      console.log('new license dataToUpdate: ', dataToUpdate);
    } else {
      // check and send only differences
      dataToUpdate = {
        licenseId: this.state.licenseId,
        cookieDuration: this.state.cookieDuration,
      };
      if (
        this.props.license &&
        this.props.license.licenseName != this.state.licenseName
      ) {
        dataToUpdate['licenseName'] = this.state.licenseName;
        console.log('dataToUpdate license name', dataToUpdate);
      }
      if (
        this.props.license &&
        this.props.license.validUntil != this.state.validUntilValue
      ) {
        dataToUpdate['validUntil'] = this.state.validUntilValue;
        console.log('dataToUpdate validUntil', dataToUpdate);
      }
      if (
        this.props.license &&
        this.state.cpm !=
          '' +
            parseFloat(parseInt(this.props.license.cpmCost) / 1000000).toFixed(
              2
            )
      ) {
        dataToUpdate['cpmCost'] =
          parseFloat(this.state.cpm) * CPM_COST_MULTIPLIER;
        dataToUpdate['currency'] = this.state.currency;
        console.log('dataToUpdate cpm', dataToUpdate);
      }
      if (
        this.props.license &&
        this.props.license.currency != this.state.currency
      ) {
        dataToUpdate['currency'] = this.state.currency;
        dataToUpdate['cpmCost'] =
          parseFloat(this.state.cpm) * CPM_COST_MULTIPLIER;
        console.log('dataToUpdate license currency', dataToUpdate);
      }

      console.log('dataToUpdate', dataToUpdate);
    }
    this.props.onNext(dataToUpdate);
  };

  checkOnChange(field, event) {
    this.setState(
      {
        [field]: event.target.value,
        disabled: true,
      },
      () => {
        /*if (this.state.partnerId != '' && this.state.licenseName != '') {
                    this.setState({ disabled: false })
                }*/
        this.setState({ disabled: false });
      }
    );
  }

  onDmpChange(dmp) {
    this.setState(
      { dmp: dmp, dmpProductId: '', dmpProductDescription: '' },
      () => {}
    );
  }
  onDmpProductChange(dmpProduct, hasPartner, dmpProductDescription = '') {
    console.log(
      'onDmpProductChange',
      dmpProduct,
      hasPartner,
      dmpProductDescription
    );
    if (dmpProduct != null || dmpProduct != undefined) {
      this.setState(
        {
          dmpProductId: dmpProduct,
          dmpProductDescription: dmpProductDescription,
          withPartnerId: hasPartner == 'true',
          currency: hasPartner == 'true' ? this.state.currency : 'USD',
          disabled: hasPartner == 'true',
          partnerId: '',
        },
        () => {
          // as a default, if we select adform we set all agencies as SEAT ID
          if (this.state.dmp === 'adform') {
            this.setState({ partnerId: 'ADF_AC', disabled: false });
          }

          // load also currencies
          axios
            .get(
              '/currencies?dmp=' +
                this.state.dmp +
                '&product=' +
                this.state.dmpProductId
            )
            .then((response) => {
              console.log('currencies list', response, response.data.body);
              this.setState({
                currencies: response.data.body.map((c) => c.currency),
              });
            });
        }
      );
    }
  }

  render() {
    const { onCancel } = this.props;

    console.log('disabled', this.state.disabled);
    return (
      <div className='row justify-content-center'>
        <div className='col-10'>
          <WhiteBox>
            <div
              style={{
                position: 'relative',
                paddingRight: 100,
              }}
            >
              <div className='row'>
                <div className='col-3'>
                  <img src='/img/license/illy-license.svg' alt='' />
                </div>
                <div className='col-9'>
                  <h3
                    style={{
                      marginTop: 26,
                    }}
                  >
                    {this.state.editMode ? 'Update license' : 'New license'}
                  </h3>

                  <p
                    style={{
                      fontSize: 'smaller',
                      color: '#797979',
                    }}
                  >
                    License your Audiences and make them available to be used in
                    your Campaign targeting
                  </p>

                  {/** show a warning on adform editing */}
                  {this.props.editMode && this.state.dmp === 'adform' && (
                    <p
                      className='alert alert-warning'
                      style={{
                        fontSize: 'smaller',
                        color: '#797979',
                      }}
                    >
                      Adform edit: please note that updating a license will
                      updates all licenses with the same audience id.
                    </p>
                  )}
                  {this.props.editMode && this.state.showMarketplaceMessage && (
                    <p
                      className='alert alert-warning'
                      style={{
                        fontSize: 'smaller',
                        color: '#797979',
                      }}
                    >
                      To change price in Google Marketplace please mail us on
                      operations@audiencerate.com
                    </p>
                  )}

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div className='col-8' style={{ padding: '0' }}>
                      <DMPFilter
                        disable={this.props.editMode}
                        showAllProductOption='false'
                        showPleaseSelectOption='true'
                        onDmpChange={this.onDmpChange.bind(this)}
                        onDmpProductChange={this.onDmpProductChange.bind(this)}
                        dmp={this.state.dmp}
                        dmpProduct={this.state.dmpProductId}
                        dmpProductDescription={this.state.dmpProductDescription}
                      />
                    </div>

                    <div
                      style={{
                        width: 'calc(33% - 16px)',
                        visibility:
                          this.state.withPartnerId === true
                            ? 'visible'
                            : 'hidden',
                      }}
                    >
                      <p style={{ marginTop: 30 }}>Enter your Seat ID</p>
                      <input
                        type='text'
                        className='form-control'
                        readOnly={
                          this.state.editMode || this.state.dmp == 'adform'
                        }
                        value={this.state.partnerId}
                        onChange={this.checkOnChange.bind(this, 'partnerId')}
                      />
                    </div>
                  </div>

                  {/* adform country and agencies selection */}
                  {this.state.dmp == 'adform' && !this.props.license && (
                    <div className='row'>
                      <div className='col-12'>
                        <AdformRights
                          disable={this.props.editMode}
                          onCountryChange={(countryId) => {
                            this.setState({ countryId: countryId });
                          }}
                          onAgencyChange={(agencyId) => {
                            console.log('agency change ' + agencyId);
                            this.setState({
                              partnerId: agencyId,
                              disabled: false,
                            });
                          }}
                        />
                      </div>
                    </div>
                  )}

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div
                      style={{
                        width: 'calc(100% - 16px)',
                      }}
                    >
                      <p style={{ marginTop: 30 }}>License Name</p>
                      <input
                        type='text'
                        disabled={true}
                        className='form-control'
                        value={this.state.licenseName}
                        onChange={this.checkOnChange.bind(this, 'licenseName')}
                      />
                    </div>
                  </div>

                  <div className='row'>
                    {/*
                                        <div
                                            className="col-4">
                                            <p style={{ marginTop: 30 }}>Valid until</p>



                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <Grid container style={{'marginBottom': '10px'}}>
                                                    <KeyboardDatePicker
                                                        disableToolbar
                                                        variant="inline"
                                                        format="MM/dd/yyyy"
                                                        id="date-picker-inline"
                                                        value={this.state.validUntil}
                                                        onChange={date =>
                                                            {
                                                                if(date == "Invalid Date")
                                                                    return;

                                                                console.log(date);
                                                                console.log(moment(date).format('DD.MM.YYYY'))
                                                                this.setState({
                                                                    //validUntil: moment(date).format('MM/dd/yyyy'),
                                                                    validUntil: date,
                                                                    validUntilValue: moment(date).valueOf()
                                                                })
                                                            }
                                                        }
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                        />
                                                    </Grid>
                                                </MuiPickersUtilsProvider>

                                        </div>

                                         */}

                    <div className='col'>
                      <p style={{ marginTop: 30 }}>CPM</p>

                      <InputGroup>
                        <input
                          type='text'
                          className='form-control'
                          value={this.state.cpm}
                          placeholder='0.00  (minimum 1.00)'
                          onChange={this.handleCMPChange}
                          disabled={this.state.disableCPM}
                        />
                        {/* disabled={this.state.editMode || this.state.withPartnerId === false} */}
                        <CurrencySelector
                          disabled={this.state.disableCPM}
                          currencies={this.state.currencies}
                          currency={this.state.currency}
                          onChangeCurrency={(currency) =>
                            this.setState({
                              currency,
                            })
                          }
                        />
                      </InputGroup>
                    </div>
                    <div className='col'>
                      <p style={{ marginTop: 30 }}>Cookie TTL</p>

                      <div className='input-group'>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='30'
                          value={this.state.cookieDuration}
                          onChange={(event) =>
                            this.setState({
                              cookieDuration: event.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className='new-segment-based-audience new-segment-based-audience--button-group'
                    style={{ marginTop: '40px' }}
                  >
                    <BorderButton
                      className='grey'
                      label='Cancel'
                      onClick={onCancel}
                    />
                    <BorderButton
                      disabled={this.state.disabled}
                      className='white very-blue-bg'
                      label='save'
                      onClick={this.handleSubmit}
                    />
                  </div>
                </div>
              </div>
            </div>
          </WhiteBox>
        </div>
      </div>
    );
  }
}
